import { useEffect } from "react";

const SITE_URL = (process.env.REACT_APP_SITE_URL || "").replace(/\/$/, "");
const SUFFIX = " | SANAA DESIGN STUDIO";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function useSeo({ title, description, path, jsonLd, noindex }) {
  useEffect(() => {
    const full = title.includes("SANAA") ? title : title + SUFFIX;
    document.title = full;
    setMeta("name", "description", description);
    setMeta("property", "og:title", full);
    setMeta("property", "og:description", description);
    setMeta("name", "twitter:title", full);
    setMeta("name", "twitter:description", description);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large");
    setMeta("property", "og:image", `${SITE_URL}/og-image.jpg`);
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (SITE_URL && path) {
      if (!canonical) {
        canonical = document.createElement("link");
        canonical.rel = "canonical";
        document.head.appendChild(canonical);
      }
      canonical.href = SITE_URL + path;
      setMeta("property", "og:url", SITE_URL + path);
    }
    let script;
    if (jsonLd) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.dataset.page = "1";
      script.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
    return () => { if (script) script.remove(); };
  }, [title, description, path, jsonLd, noindex]);
}
